import {
	canonical,
	capitalizeFirstLetter,
	generateBreadcrumbStructuredDataMarkup,
} from "@/common/functions";

export default function() {
	if (this.isError) {
		return {
			title: this.$t("WordscapesErrorPageMetaTitle"),
			meta: [
				{
					name: "description",
					content: this.$t("WordscapesErrorPageMetaDescription"),
				},
			],
		};
	}

	if (!this.packInfo || !this.packInfo.name) return {};

	const packs = this.packInfo.levels.slice(0, 3);
	const obj = packs.reduce((acc, item, index) => {
		acc[`LevelNumber_${index + 1}`] = item.level;
		acc[`PackName_${index + 1}`] = capitalizeFirstLetter(item.name);
		return acc;
	}, {});
	return {
		title: this.$t("WordscapesPackPageMetaTitle", {
			PackName: capitalizeFirstLetter(this.packInfo.name),
		}),
		meta: [
			{
				name: "description",
				content: this.$t("WordscapesPackPageMetaDescription", {
					PackName: capitalizeFirstLetter(this.packInfo.name),
					...obj,
				}),
			},
		],
		script: [
			{
				type: "application/ld+json",
				json: generateBreadcrumbStructuredDataMarkup([
					{
						name: capitalizeFirstLetter(this.packInfo.group),
						path: this.$t("BreadcrumbWordscapesGroupPageUrl", {
							GroupName: this.packInfo.group,
						}),
					},
					{
						name: capitalizeFirstLetter(this.packInfo.name),
						path: this.$route.path,
					},
				]),
			},
		],
		link: [canonical(this.$route)],
	};
}
